export default __webpack_public_path__ + "media/landscape/logo_mailchimp-18aed2b5.svg";